// components/Header.jsx
import React, { useState } from 'react';
import './Header.css';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="nav-left">
        <h2>Teja Praveen Deva Raju</h2>
      </div>

      <div className={`nav-right ${menuOpen ? 'open' : ''}`}>
        <a href="#home">About</a>
        <a href="#certificates">Experience</a>
        <a href="#projects">Projects</a>
        <a href="#contact">Contact</a>
      </div>

 <div className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </header>
  );
}
